import React from "react";

const MainContent = () => {
  return <div>Main Content</div>;
};

export default MainContent;
